import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=3731903b&scoped=true&"
import script from "./pedidos.vue?vue&type=script&lang=js&"
export * from "./pedidos.vue?vue&type=script&lang=js&"
import style0 from "./pedidos.vue?vue&type=style&index=0&id=3731903b&prod&scoped=true&lang=css&"
import style1 from "./pedidos.vue?vue&type=style&index=1&id=3731903b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731903b",
  null
  
)

export default component.exports